module.exports = __webpack_public_path__ + "4ed983bb6267431720febfdc3d7e53d1.pdf";